// extracted by mini-css-extract-plugin
module.exports = {"presentation_input":"InputPresentation_presentation_input__32KkF","with_label":"InputPresentation_with_label__2y59u"};